import { ChatViewLayoutProps } from '../../../../layouts/chat-view-layout/ChatViewLayout';
import PromptGallery from '../prompt-gallery/PromptGallery';
import styles from './PromptView.module.scss';

const PromptView = (props: ChatViewLayoutProps) => {
    return <div className={styles['prompt-view']}>
        <PromptGallery {...props} />
    </div>;
};

export default PromptView;